import React from 'react';
import { Button } from 'reactstrap';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { Loading } from '../common/LoadingComponent';
import { Lock, Eye, EyeOff } from '../../icons';
import { Link } from 'react-router-dom';

const required   = (val) => val && val.length;
const maxLength  = (len) => (val) => !(val) || (val.length <= len);
const minLength  = (len) => (val) => val && (val.length >= len);

function ResetPassword(props) {
    function handleResetPassword(values) {
        props.updatePassword(props.token, values.password);
    }

    if (props.isUpdatingPassword) {
        return (
            <div className="auth-page">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-5"><div className="auth-card text-center"><Loading /></div></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-page">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-5 col-lg-4">
                        <div className="auth-card">
                            <div style={{ width: 52, height: 52, borderRadius: 14, background: 'var(--primary-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
                                <Lock size={26} strokeWidth={1.8} color="var(--primary)" />
                            </div>
                            <h1 className="auth-title">Nouveau mot de passe</h1>
                            <p className="auth-subtitle">
                                Choisissez un mot de passe sécurisé d'au moins 8 caractères.
                            </p>

                            <LocalForm
                                onSubmit={(values) => handleResetPassword(values)}
                                validators={{
                                    '': { passwordsMatch: (vals) => vals.password === vals.confirmpassword },
                                    password:        { required, maxLength: maxLength(30), minLength: minLength(8) },
                                    confirmpassword: { required, maxLength: maxLength(30), minLength: minLength(8) },
                                }}
                            >
                                <div className="form-group mb-3">
                                    <Control.password model=".password" id="password" name="password"
                                        placeholder="Nouveau mot de passe"
                                        className="form-control auth-input"
                                        validators={{ required, maxLength: maxLength(30), minLength: minLength(8) }}
                                    />
                                    <Errors className="errors" model=".password" show="touched"
                                        messages={{ required: 'Champ requis.', minLength: '8 caractères minimum.', maxLength: '30 caractères maximum.' }} />
                                </div>
                                <div className="form-group mb-4">
                                    <Control.password model=".confirmpassword" id="confirmpassword" name="confirmpassword"
                                        placeholder="Confirmer le mot de passe"
                                        className="form-control auth-input"
                                        validators={{ required, maxLength: maxLength(30), minLength: minLength(8) }}
                                    />
                                    <Errors className="errors" model=".confirmpassword" show="touched"
                                        messages={{ required: 'Champ requis.', minLength: '8 caractères minimum.', passwordsMatch: 'Les mots de passe ne correspondent pas.' }} />
                                </div>
                                <Button type="submit" color="primary" className="auth-submit mb-3">
                                    Changer le mot de passe
                                </Button>
                            </LocalForm>

                            <div className="auth-footer">
                                <Link to="/login" className="auth-link">Retour à la connexion</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResetPassword;
